exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".license-error-page__content {\n  position: relative;\n}\n.license-error-page__textarea {\n  width: 60vw;\n}\n", ""]);

